import * as ROUTES from './routes';
const privateRoutes = [
    ROUTES.CMS_SUBS.gd.path,
    ROUTES.CMS_SUBS.content.path,
];

export default privateRoutes;